import React, { useEffect, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Input, FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';

const defaultCancelSubscriptionReasons = [
  'Just learning about Mender',
  'Too expensive',
  'Lack of features',
  'Mender did not work as expected',
  'Chose a different solution',
  'My project is delayed',
  'My project is cancelled'
];

export const CancelRequestDialog = ({ onCancel, onSubmit }) => {
  const [confirm, setConfirm] = useState(false);
  const [cancelSubscriptionReason, setCancelSubscriptionReason] = useState('');
  const [cancelSubscriptionReasonOther, setCancelSubscriptionReasonOther] = useState('');
  const [cancelSubscriptionSuggestions, setCancelSubscriptionSuggestions] = useState('');
  const [cancelSubscriptionReasons] = useState(defaultCancelSubscriptionReasons.sort(() => Math.random() - 0.5).concat(['Other']));

  useEffect(() => {
    if (cancelSubscriptionReason !== 'Other') {
      setCancelSubscriptionReasonOther('');
    }
  }, [cancelSubscriptionReason]);

  return (
    <Dialog open={true}>
      <DialogTitle>{!confirm ? 'Cancel subscription and deactivate account?' : 'Confirm deactivation'}</DialogTitle>
      {!confirm ? (
        <DialogContent>
          <p className="margin-top-small">
            We&#39;ll be sorry to see you go. If you&#39;re sure you&#39;re ready to deactivate your account please let us know the reason you&#39;re canceling,
            and we&#39;ll start the process.
          </p>
          <p>Please select the reason for your cancellation to help us improve our service:</p>
          <FormControl component="fieldset" style={{ marginTop: '0' }}>
            <RadioGroup name="cancellation-selection" onChange={e => setCancelSubscriptionReason(e.target.value)}>
              {cancelSubscriptionReasons.map((item, index) => (
                <FormControlLabel value={item} control={<Radio />} label={item} key={index} style={{ marginTop: '0px' }} />
              ))}
            </RadioGroup>
            <Input
              id="reason_other"
              name="reason_other"
              value={cancelSubscriptionReasonOther}
              disabled={cancelSubscriptionReason !== 'Other'}
              onChange={e => setCancelSubscriptionReasonOther(e.target.value)}
              placeholder="Fill in reason"
              style={{ marginLeft: '30px' }}
            />
          </FormControl>
          <p className="margin-top">Which key areas should we improve?</p>
          <Input
            id="suggestions"
            name="suggestions"
            className="margin-bottom"
            value={cancelSubscriptionSuggestions}
            onChange={e => setCancelSubscriptionSuggestions(e.target.value)}
            placeholder="Fill in suggestions"
            style={{ width: '100%' }}
          />
        </DialogContent>
      ) : (
        <DialogContent>
          <p>
            <strong>You can now click &#39;confirm&#39; to cancel your plan and deactivate your account.</strong>
          </p>
          <p>
            We will start the process of closing your account. Meanwhile, you can continue using Mender until the end of the current month. You will receive
            your final charge for this period at the beginning of next month.
          </p>
          <p>Thank you for using Mender!</p>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onCancel}>Stay subscribed</Button>
        <div style={{ flexGrow: 1 }} />
        {!confirm ? (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setConfirm(true)}
            disabled={cancelSubscriptionReason == '' || (cancelSubscriptionReason == 'Other' && cancelSubscriptionReasonOther == '')}
          >
            Continue to deactivate
          </Button>
        ) : (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => onSubmit((cancelSubscriptionReasonOther || cancelSubscriptionReason) + '\n' + cancelSubscriptionSuggestions)}
          >
            Confirm deactivation
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CancelRequestDialog;
